import { HeadCell } from 'shell/components/shared/table/types';
import { CitizenshipVM } from 'shell/view-models/citizenship';

export const headCellsCitizenshipEditMode: HeadCell<CitizenshipVM, keyof CitizenshipVM>[] = [
  {
    id: 'code',
    label: 'Codice',
  },
  {
    id: 'citizenship',
    label: 'Cittadinanza',
  },
  {
    id: 'validityDate',
    label: 'Data validità',
  },
  {
    id: 'note',
    label: 'Note',
  },
  {
    id: 'action',
    label: 'Azione',
  },
];
